export var JurisdictionsEnumKey;
(function (JurisdictionsEnumKey) {
    JurisdictionsEnumKey["GLOBAL"] = "GLOBAL";
    JurisdictionsEnumKey["GE"] = "GE";
    JurisdictionsEnumKey["UA"] = "UA";
    JurisdictionsEnumKey["EU"] = "EU";
})(JurisdictionsEnumKey || (JurisdictionsEnumKey = {}));
//# sourceMappingURL=jurisdiction.js.map